import React from "react";
import {
    Box,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Divider,
    Dialog,
    Typography
} from "@mui/material";
import { styled } from "@mui/system";
import CustomAutocomplete from "../autocomplete/Autocomplete";
import ButtonCta1 from "../button/ButtonCta1";
import { CustomTextField } from "../../helpers/helper";
import NoResultFound from "../noResultFound/NoResultFound";

const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
        borderRadius: 12,
    },
}));

const labelStyle = {
    fontSize: "14px",
    marginBottom: "8px",
    fontWeight: 500,
    color: "#333",
};

const requiredAr = {
    color: "red",
    marginLeft: "4px",
};

const MonthlyExpenseTargetDialog = ({
    open,
    onClose,
    onConfirm,
    monthlyExp = [],
    selectedProgram,
    setMonthlyExp,
    validYearExpTargetMsg = false,
    getOrgLabel,
    handleInputFocus,
    title = "Add Monthly Expense Target",
    subTitle = "Please add the monthly expense target values for the Program " + selectedProgram,
    leftButtonText = "Cancel",
    rightButtonText = "Switch",
}) => {
    const handleChange = (e, data) => {
        const { name, value } = e.target;
        const modifiedData = monthlyExp?.map((obj) => {
            if (obj.month === data.month) {
                return { ...obj, [name]: value };
            }
            return obj;
        });
        setMonthlyExp(modifiedData);
    };

    return (
        <CustomDialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="alert-dialog-title"
                sx={{
                    color: "#a50218",
                    fontFamily: "Montserrat",
                    padding: "32px 32px 12px 32px",
                    fontWeight: 600,
                }}
            >
                {title}
            </DialogTitle>

            <DialogContent sx={{ minWidth: "600px", padding: "20px 32px" }}>
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{ fontSize: "14px", fontFamily: "Montserrat", fontWeight: 500 }}
                    dangerouslySetInnerHTML={{ __html: subTitle }}
                />
                {validYearExpTargetMsg && (
                    <Typography
                        sx={{
                            color: "red",
                            fontSize: "14px",
                            fontWeight: 500,
                            fontFamily: "Montserrat",
                        }}
                    >
                        Sum of monthly expense target should be equal to yearly expense target value.
                    </Typography>
                )}
                <div
                    style={{
                        borderRadius: "12px",
                        backgroundColor: "#fff",
                        padding: "0 32px 32px 0",
                        maxHeight: "calc(100vh - 240px)",
                        overflowY: "auto",
                    }}
                    className="table_container"
                >
                    <div style={labelsDiv}>
                        <div style={{ width: "360px", paddingBottom: "12px" }}>Month</div>
                        <div style={{ width: "300px", paddingBottom: "12px" }}>Target</div>
                        <div style={{ width: "300px", paddingBottom: "12px" }}>Expenses</div>
                    </div>
                    {monthlyExp?.length > 0 ? (
                        <>
                            {monthlyExp &&
                                monthlyExp?.map((elem, i) => (
                                    <Box
                                        key={i}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            columnGap: "60px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        <div style={mainDiv}>
                                            <div style={childDiv}>
                                                <div style={container}>
                                                    <div style={contentDiv}>
                                                        <div style={acquisitionRetention1}>
                                                            {elem?.month || ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "300px",
                                            }}
                                        >
                                            <CustomTextField
                                                placeholder="0.00"
                                                sx={{
                                                    width: "100%",
                                                }}
                                                id="outlined-basic"
                                                variant="outlined"
                                                type="number"
                                                name="target"
                                                value={elem?.target || ""}
                                                onChange={(e) => handleChange(e, elem)}
                                                onFocus={handleInputFocus}
                                                InputProps={{
                                                    startAdornment: (
                                                        <span style={{ marginRight: 5 }}>$</span>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "300px",
                                            }}
                                        >
                                            <CustomTextField
                                                placeholder="0.00"
                                                sx={{
                                                    width: "100%",
                                                }}
                                                id="outlined-basic"
                                                variant="outlined"
                                                type="number"
                                                name="expense"
                                                value={elem?.expense || ""}
                                                onChange={(e) => handleChange(e, elem)}
                                                onFocus={handleInputFocus}
                                                InputProps={{
                                                    startAdornment: (
                                                        <span style={{ marginRight: 5 }}>$</span>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                ))}
                        </>
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "calc(100vh - 320px)",
                            }}
                        >
                            <NoResultFound description="" />
                        </div>
                    )}
                </div>
            </DialogContent>

            <DialogActions sx={{ padding: "0 32px 20px 32px" }}>
                <Box>
                    <ButtonCta1
                        text={leftButtonText}
                        variant="contained"
                        onClick={onClose}
                        bgColor="#e0e0e0"
                        color="#5a5a5a"
                    />
                </Box>
                <Box style={{ marginLeft: "20px" }}>
                    <ButtonCta1
                        text={rightButtonText}
                        variant="contained"
                        onClick={onConfirm}
                        autoFocus
                        bgColor="#a50218"
                        color="#fff"
                    // disabled={!organization?.environmentId}
                    />
                </Box>
            </DialogActions>
        </CustomDialog>
    );
};

export default MonthlyExpenseTargetDialog;

const labelsDiv = {
    display: "flex",
    columnGap: "40px",
    fontSize: "14px",
    color: "rgb(138, 138, 138)",
    fontWeight: 600,
    fontFamily: "Montserrat",
    marginBottom: "32px",
    borderBottom: "2px solid #e0e0e0",
    paddingTop: "32px",
    position: "sticky",
    top: 0,
    background: "#fff",
    zIndex: 111,
};

const mainDiv = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    // marginTop: "23px",
    width: "340px",
};

const childDiv = {
    display: "flex",
    flexDirection: "column",
    // paddingRight: "40px",
    rowGap: "20px",
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "100%",
};

const container = {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    height: "50px",
    width: "100%",
};

const contentDiv = {
    padding: "12px",
};

const acquisitionRetention1 = {
    fontSize: "14px",
    letterSpacing: "-0.02em",
    lineHeight: "20px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#5a5a5a",
    textAlign: "left",
    display: "inline-block",
    width: "100%",
};
